import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { OrganizationPaymentMethod } from '@uzurv/clara';
import { isNullOrUndefined } from '@uzurv/core';

export class FareCollectionValidators extends Validators {
  static voucherNumberValidator(organizationPaymentMethod: OrganizationPaymentMethod): ValidatorFn {
    return (abstractControl: AbstractControl): ValidationErrors | null => {
      const validationErrors: { [key: string]: boolean } = {};

      if (!isNullOrUndefined(organizationPaymentMethod)) {
        if (isNullOrUndefined(abstractControl.value) || abstractControl.value.length === 0) {
          if (organizationPaymentMethod.ticketNumberRequired !== false) {
            validationErrors['required'] = true;
          }
        } else {
          if (isNullOrUndefined(organizationPaymentMethod.ticketNumberRegex)) {
            const alphaNumericRegex = new RegExp(/^[a-zA-Z0-9]*$/);
            if (!alphaNumericRegex.test(abstractControl.value)) {
              validationErrors['noSpecialCharacters'] = true;
            }
          } else {
            const regex = new RegExp(organizationPaymentMethod.ticketNumberRegex);
            const validValue = regex.test(abstractControl.value);

            if (!validValue) {
              validationErrors['invalidVoucherNumber'] = true;
            }
          }
        }
      }

      return validationErrors;
    };
  }

  static voucherValueValidator(organizationPaymentMethod: OrganizationPaymentMethod): ValidatorFn {
    return (abstractControl: AbstractControl): ValidationErrors | null => {
      const validationErrors: { [key: string]: boolean } = {};
      if (!isNullOrUndefined(organizationPaymentMethod) && !isNullOrUndefined(abstractControl.value) && abstractControl.value > 0) {
        if (!isNullOrUndefined(organizationPaymentMethod.ticketValidValues) && organizationPaymentMethod.ticketValidValues.length > 0) {
          const isValidValue = organizationPaymentMethod.ticketValidValues.some((tcv) => tcv === +abstractControl.value * 100);
          if (!isValidValue) {
            validationErrors['invalidVoucherValue'] = true;
          }
        }
      }
      return validationErrors;
    };
  }
}
